import CompLayout from "@/pcomponents/comp/layout/layout";
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SelectBoxBar from "@/pcomponents/common/crud/write/select_box_bar";
import TextbookStuUseListArea from "@/pages/comp/book_order/comp_textbook/common/stu_use_list";
import StudyStuProgressArea from "@/pages/comp/plan/study/stu_progress/common/manage";

function StudyStuProgressPage() {
  let user = useSelector((state: any) => state.user);

  let is_show_tab = false;
  let default_tab_value = "mtextbook";
  if (user.comp_sort_detail == "growple") {
    is_show_tab = true;
    default_tab_value = "study_title";
  }

  const [page_tab, set_page_tab] = useState(default_tab_value);//study_title,mtextbook
  let page_tab_arr = [
    { value: "study_title", text: "학원교재" },
    { value: "mtextbook", text: "주문교재" },
  ];

  return (
    <CompLayout isConTitle={false}>
      {is_show_tab &&
        <div>
          <SelectBoxBar
            valueTextArr={page_tab_arr}
            value={page_tab}
            name="page_tab"
            on_change={(inData: any) => {
              set_page_tab(inData.value);
            }}
            is_same_value_empty={false}
          ></SelectBoxBar>
        </div>
      }
      {page_tab == "mtextbook" &&
        <TextbookStuUseListArea
          is_preview_only_first={true}
        ></TextbookStuUseListArea>
      }
      {page_tab == "study_title" &&
        <StudyStuProgressArea></StudyStuProgressArea>}
    </CompLayout>
  );
}

export default StudyStuProgressPage;